import { render } from "./SectionTitle.vue?vue&type=template&id=112d8e7a&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=112d8e7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112d8e7a"]])

export default __exports__